import { sessionSchema } from '@canopee/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../api/client.js';

export const sessionQueryKey = ['session'] as const;

export function useSession() {
  return useQuery({
    queryKey: sessionQueryKey,
    queryFn: ({ signal }) => apiRequest('/api/v1/auth/me', sessionSchema, { signal }),
    retry: false,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}

export function broadcastLogout(): void {
  if (typeof BroadcastChannel === 'undefined') return;
  const channel = new BroadcastChannel('canopee-auth');
  channel.postMessage({ type: 'logout' });
  channel.close();
}
